import { render, staticRenderFns } from "./PickRating.vue?vue&type=template&id=480ed174&scoped=true"
import script from "./PickRating.vue?vue&type=script&lang=js"
export * from "./PickRating.vue?vue&type=script&lang=js"
import style0 from "./PickRating.vue?vue&type=style&index=0&id=480ed174&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480ed174",
  null
  
)

export default component.exports